export default __webpack_public_path__ + "static/galvanic-ea1eec8ddd37519a7683f543f5eeeb4e.jpg";